import React from 'react';
function NotFound() {
    return (
        <div className={'h-100'}>
            <h1>Error: Page not found</h1>
        </div>
    );
}
export default NotFound;